import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AdminSitemapComponent } from './admin-sitemap.component';

const routes: Routes = [
  {
    path: '', component: AdminSitemapComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminSitemapRoutingModule { }
